import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

var AlertAppearanceTypes;
(function (AlertAppearanceTypes) {
    AlertAppearanceTypes["ERROR"] = "error";
    AlertAppearanceTypes["WARNING"] = "warning";
    AlertAppearanceTypes["PRIMARY"] = "primary";
    AlertAppearanceTypes["SECONDARY"] = "secondary";
})(AlertAppearanceTypes || (AlertAppearanceTypes = {}));

const rocheEditorAlertCss = ":host{display:block;margin-top:3rem}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .alert{align-items:center;display:flex;flex-direction:column;padding:1.5625rem;height:auto;min-height:9.375rem;justify-content:center;width:100%}:host .alert__headline{padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:1.875rem;line-height:2.25rem;font-weight:400}:host .alert__headline strong{font-weight:600}@media (min-width: 48rem){:host .alert__headline{font-size:2.5rem;line-height:3rem}}@media (min-width: 90rem){:host .alert__headline{font-size:3rem;line-height:3.625rem}}:host .alert__text{padding:1.25rem 0 0;font-size:1.125rem;font-weight:200}:host .alert--error{background-color:#ffd2d4}:host .alert--primary{background-color:#85a0e6}:host .alert--secondary{background-color:#dbd6d1}:host .alert--warning{background-color:#fbdd7a}";
const RocheEditorAlertStyle0 = rocheEditorAlertCss;

const RocheEditorAlert$1 = /*@__PURE__*/ proxyCustomElement(class RocheEditorAlert extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.headline = undefined;
        this.text = undefined;
        this.type = AlertAppearanceTypes.ERROR;
    }
    render() {
        const alertClasses = {
            alert: true,
            [`alert--${this.type}`]: true,
        };
        return (h("div", { key: '329f732c21c4bbff31797c826c2849d5211f4a11', class: alertClasses }, this.headline && (h("div", { class: 'alert__headline' }, this.headline)), this.text && (h("div", { class: 'alert__text' }, this.text))));
    }
    static get style() { return RocheEditorAlertStyle0; }
}, [1, "roche-editor-alert", {
        "headline": [1],
        "text": [1],
        "type": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-editor-alert"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-editor-alert":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheEditorAlert$1);
            }
            break;
    } });
}

const RocheEditorAlert = RocheEditorAlert$1;
const defineCustomElement = defineCustomElement$1;

export { RocheEditorAlert, defineCustomElement };

//# sourceMappingURL=roche-editor-alert.js.map